import { render, staticRenderFns } from "./gBottom.vue?vue&type=template&id=05af633e&scoped=true&"
import script from "./gBottom.vue?vue&type=script&lang=js&"
export * from "./gBottom.vue?vue&type=script&lang=js&"
import style0 from "./gBottom.vue?vue&type=style&index=0&id=05af633e&lang=scss&scoped=true&"
import style1 from "./gBottom.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./gBottom.vue?vue&type=style&index=2&id=05af633e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af633e",
  null
  
)

export default component.exports